const elementToggleFunc = function (elem) { elem.classList.toggle("active"); }

export {elementToggleFunc}